import { ReactNode } from 'react';

import cn from './styles.module.sass';

export interface IStepProps {
    stepNumber: number;
    description: ReactNode;
}

export const Step = ({ stepNumber, description }: IStepProps) => {
    return (
        <div className={cn.container}>
            <h4>Шаг {stepNumber}</h4>
            <p>{description}</p>
        </div>
    );
};
